import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import Logger from "./lib/logger";
import vuetify from "./plugins/vuetify";
import "./registerServiceWorker";
import router from "./router";

import store from "./store";
import VueClipboard from "vue-clipboard2";
// import vueGtag from "vue-gtag";
// import GtmDataLayer from './gtm-datalayer'
// Vue.use(GtmDataLayer)

var VueTouch = require("vue-touch");
VueTouch.registerCustomEvent("doubletap", {
  type: "tap",
  taps: 2,
});
Vue.use(VueTouch, { name: "v-touch" });
Vue.config.productionTip = false;

// global.$config = require('../public/mapconfig.json')

Vue.use(Logger, process.env.NODE_ENV);

global.KWB_MODE = "general";
if (process.env.VUE_APP_NOT_SECRET_CODE) {
  global.KWB_MODE = process.env.VUE_APP_NOT_SECRET_CODE;
}
Logger.debug("KWB_MODE=" + global.KWB_MODE);

global.TEST_MODE = "release";
if (process.env.VUE_APP_MODE_TEST) {
  global.TEST_MODE = process.env.VUE_APP_MODE_TEST;
}
Logger.debug("TEST_MODE=" + global.TEST_MODE);

Vue.use(VueClipboard);

// if (process.env.NODE_ENV === "production") {
// Vue.use(
//   vueGtag,
//   {
//     config: { id: "UA-213718306-1" },
//   },
//   router
// );
// }

router.afterEach((to, from) => {
  // Logger.info("[router]router.afterEach");
  // Logger.info("[router]dataLayer.push");
  // Logger.dir({
  //   event: 'vuePageView',
  //   'pagePath': to.path,
  //   'title': to.path,
  // });
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'vuePageView',
    'pagePath': to.fullPath,
    'pageTitle': to.path,
  });
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
